"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentFile_1 = require("../types/AttachmentFile");
var owa_trace_1 = require("owa-trace");
function createMailItemFiles(subjects, latestItemIds) {
    if (subjects.length != latestItemIds.length) {
        owa_trace_1.trace.error('The sizes of subjects and latestItemIds are different');
        return null;
    }
    var mailItemList = [];
    for (var i = 0; i < subjects.length; i++) {
        var conversation = {
            fileType: AttachmentFile_1.AttachmentFileType.MailItem,
            name: subjects[i],
            size: 0,
            itemId: latestItemIds[i],
        };
        mailItemList.push(conversation);
    }
    return mailItemList;
}
exports.default = createMailItemFiles;
//# sourceMappingURL=createMailItemFiles.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-attachment-common/lib/utils/createMailItemFiles.js
// module id = 4044
// module chunks = 100